import { request, post, get } from '@/plugins/requestU'

/**
 * 根据Ux-Access-Token获取用户信息
 * @param {*} data 
 * @returns 
 */
export function detailU(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/detailU', data);
}
/**
 * 登出
 * @param {*} data 
 * @returns 
 */
export function loginOut(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/loginOut', data);
}

/**
 * 修改昵称
 * @param {*} data 
 * @returns 
 */
export function updateName(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/updateName', data);
}
/**
 * 设置密码
 * @param {*} data 
 * @returns 
 */
export function setPwd(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/setPwd', data);
}
/**
 * 修改密码
 * @param {*} data 
 * @returns 
 */
export function updatePwd(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/updatePwd', data);
}
/**
 * 更改手机号
 * @param {*} data 
 * @returns 
 */
export function changePhoneNumber(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/changePhoneNumber', data);
}
/**
 * 验证验证码
 * @param {*} data 
 * @returns 
 */
export function validPhoneCode(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/validPhoneCode', data);
}
/**
 * 验证验证码
 * @param {*} data 
 * @returns 
 */
export function getListZtb(data) {
    return post('/guarantee-service/v0.1/guarantee/guarantee/tg/list', data);
}
/**
 * 获取验证码
 * @param {} data 
 * @returns 
 */
export function getCaptcha(data) {
    return post('/guarantee/v0.1/guarantee/user/tu/captcha', data);
}